'use strict';

var env = require('../env');

if ('unknown' == env.type) {
  throw new Error('Unknown environment');
}

module.exports =
  env.isNode ? require('./node') :
    env.isMongo ? require('./collection') :
      require('./collection');




//////////////////
// WEBPACK FOOTER
// ./~/mquery/lib/collection/index.js
// module id = 387
// module chunks = 0